import cn from "classnames"

import { Avatar, Flex } from "@/atoms"
import { isCI, isNA, isScanning } from "@/domain/scan-history"
import { ImageIcon } from "@/icons"
import { InformationPopover } from "@/molecules/InformationPopover"
import { CreatorCell } from "@/pages/ReportsPage/components/molecules/CreatorCell"

import styles from "./InitiatorCell.module.scss"

import type { TFunction } from "@/hooks/useTranslation"
import type { getScanHistorySelector } from "@/pages/GovernancePage/applications/scan-history/useScanHistory.selector"

export const InitiatorCell = (t: TFunction) =>
  function InitiatorCellComponent(
    displayName: string,
    record: ReturnType<typeof getScanHistorySelector>["data"][number]
  ) {
    const isOnPrem = isCI(record)
    const isPlaceholder = isNA(record) || isScanning(record)

    return (
      <span
        className={cn(styles.container, {
          [styles.containerNoPolicy]: isPlaceholder
        })}
      >
        {isOnPrem && (
          <InformationPopover.Popover
            placement="auto"
            content={
              <InformationPopover.CommonTemplate
                title={
                  <Flex gap={8} align="center">
                    <ImageIcon
                      hideTooltip
                      imageSource="local"
                      className={styles.popoverContentIcon}
                    />
                    <span>
                      {t("governance.scanHistory.resourceType.ci_open_source")}
                    </span>
                  </Flex>
                }
              >
                <div className={styles.popoverContent}>
                  <span className={styles.popoverContentLabel}>
                    {t("general.serviceKeyName")}
                  </span>
                  <span>{record.initiator || "-"}</span>
                </div>
              </InformationPopover.CommonTemplate>
            }
          >
            <Avatar size="small">
              <ImageIcon
                hideTooltip
                imageSource="local"
                className={styles.iconNoPolicy}
              />
            </Avatar>
          </InformationPopover.Popover>
        )}
        {!isOnPrem && CreatorCell(displayName, record)}
      </span>
    )
  }
